import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Dialog, ICON_SIZE } from '../design-system';
import { getTierDisplayName } from '@papper/shared/reedle/tiers';

const UsageUpgradeModal = ({ onClose, confirmModal, currentTier, handleConfirmUpgrade, actionLoading }) => {
  const { t } = useTranslation('modals');
  return (
    <Dialog
      isOpen
      onClose={onClose}
      ariaLabel={t('usage.plan.confirmUpgradeTitle')}
      showClose={false}
      className="usage-coming-soon-modal"
    >
      <h3>{t('usage.plan.confirmUpgradeTitle')}</h3>

      <div className="usage-upgrade-details">
        <div className="usage-upgrade-tier">
          <span className="tier-from">{getTierDisplayName(currentTier)}</span>
          <span className="tier-arrow">→</span>
          <span className="tier-to">{getTierDisplayName(confirmModal.targetTier)}</span>
        </div>

        <div className="usage-proration-breakdown">
          <div className="proration-item credit">
            <span className="label">{t('usage.plan.prorationCredit')}</span>
            <span className="value">-${confirmModal.proration.credit.toFixed(2)}</span>
          </div>
          <div className="proration-item charge">
            <span className="label">{t('usage.plan.prorationCharge')}</span>
            <span className="value">+${confirmModal.proration.charge.toFixed(2)}</span>
          </div>
          <div className="proration-divider"></div>
          <div className="proration-item total">
            <span className="label">{t('usage.plan.totalCharge')}</span>
            <span className="value">${confirmModal.proration.netAmount.toFixed(2)}</span>
          </div>
        </div>

        <p className="usage-upgrade-note">
          {t('usage.plan.confirmUpgradeMessage', {
            amount: confirmModal.proration.netAmount.toFixed(2),
            tier: getTierDisplayName(confirmModal.targetTier)
          })}
        </p>
      </div>

      <div className="usage-confirm-buttons">
        <button
          className="usage-confirm-btn cancel"
          onClick={onClose}
          disabled={actionLoading !== null}
        >
          {t('common.cancel', { defaultValue: 'Cancel' })}
        </button>
        <button
          className="usage-confirm-btn confirm upgrade"
          onClick={handleConfirmUpgrade}
          disabled={actionLoading !== null}
        >
          {actionLoading?.startsWith('subscribe:') ? (
            <><Loader2 size={ICON_SIZE.xs} className="spin" /> {t('usage.plan.processing')}</>
          ) : (
            t('usage.plan.confirmUpgrade')
          )}
        </button>
      </div>
    </Dialog>
  );
};

export default UsageUpgradeModal;
